import LeafSponsorOrSponsorAndPlatinum from "../SponsorDetail/LeafSponsorOrSponsorAndPlatinum/SponsorOrSponsorAndPlatinum";
import LeafPlatinumSponsor from "../SponsorDetail/LeafPlatinumSponsor/PlatinumSponsor";
import LeafInternationalSponsor from "../SponsorDetail/LeafInternationalSponsor/InternationalSponsor";
import LeafFosterOrFosterAndPlatinumSponsor from "../SponsorDetail/LeafFosterOrFosterAndPlatinumSponsor/FosterOrFosterAndPlatinumSponsor";
import "./Sponsorship.scss";

type SponsorPhone = {
  displayNumber: string;
  extension: string;
  number: string;
  outOfCountryCallingNumber: string;
};

type SponsorAddress = {
  type: string;
  addressLines: string[];
  municipality: string;
  region: string;
  postalCode: string;
  country: string;
};

type SponsorContactFields = {
  name?: string;
  nameLocal?: string;
  displayName?: string;
  privacyFlag?: boolean;
  phone?: SponsorPhone;
  email?: string;
  address?: SponsorAddress;
};

export type BasicSponsor = {
  aboNo: string;
  affNo: string;
  isValid: boolean;
} & SponsorContactFields;

type Sponsor = {
  isPlatinum: boolean;
} & BasicSponsor;

type Props = {
  sponsor: Sponsor;
  platinumSponsor: BasicSponsor;
  internationalSponsor: BasicSponsor;
  fosterSponsor: Sponsor;
  show?: boolean;
};

const Sponsorship = (props: Props) => {
  const { sponsor, platinumSponsor, internationalSponsor, fosterSponsor, show = true } = props;

  if (show === false) {
    return <></>;
  }

  return (
    <div className="leaf-sponsorship">
      <LeafSponsorOrSponsorAndPlatinum sponsor={sponsor} fosterSponsor={fosterSponsor} />
      <LeafPlatinumSponsor sponsor={sponsor} platinumSponsor={platinumSponsor} fosterSponsor={fosterSponsor} />
      <LeafInternationalSponsor internationalSponsor={internationalSponsor} />
      <LeafFosterOrFosterAndPlatinumSponsor fosterSponsor={fosterSponsor} />
    </div>
  );
};

export default Sponsorship;
